import { Group, Skeleton, Stack, Text } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import BarChart from '../../components/elements/BarChart';
import Card from '../../components/elements/Card';
import dayjs from 'dayjs';
import { getChartPerbandinganPoint } from '../../services/report-gamification';
import { useQuery } from '@tanstack/react-query';

export default function ChartPerbandinganPoint() {
  const [dataChart, setDataChart] = useState([]);

  const fetchedDataPerbandinganPoint = useQuery({
    queryKey: [`chartPointComparison`],
    queryFn: () => getChartPerbandinganPoint(),
    enabled: true
  });

  const {
    data: dataPointComparison,
    isLoading,
    isError
  } = fetchedDataPerbandinganPoint;

  useEffect(() => {
    if (dataChart.length === 0 && dataPointComparison?.data?.data) {
      const _modifiedData = dataPointComparison?.data?.data
        .sort((a, b) => a.month - b.month)
        .map((item) => {
          return {
            ...item,
            label: dayjs()
              .month(item.month - 1)
              .format('MMMM')
          };
        });
      setDataChart(_modifiedData);
    }
  }, [dataPointComparison, dataChart]);

  const renderContent = () => (
    <BarChart
      chartKeys={['totalPoint', 'totalRedeem']}
      chartLabels={['Point', 'Redeem']}
      chartColors={['#7B2183', '#75B843']}
      data={dataChart || []}
      loading={isLoading}
      isError={isError}
      onLoad={() => fetchedDataPerbandinganPoint.refetch()}
      chartLabelPosition="bottom"
      chartHeight={150}
    />
  );

  return (
    <Card flex={1} h={'100%'}>
      <Stack gap={'xs'} h={'100%'}>
        <Group justify="space-between">
          <Text className="text-sm-semibold">Redeem & Earning Point</Text>
          <Text className="text-xs-medium" c="gray">
            last 6 month
          </Text>
        </Group>
        {isLoading && <Skeleton height={150} />}
        {!isLoading && renderContent()}
      </Stack>
    </Card>
  );
}
